import React from "react";
import ReactECharts from "echarts-for-react";
import { Box } from "@mui/material";

// let cardDetails = {};
// cardDetails.categoryDistribution = {
//   process: 40,
//   customer: 25,
//   agent: 20,
//   technology: 15,
// };

const CategoryDistribution = ({ cardDetails, onCategoryClick }) => {

  const categories = cardDetails?.responsibleCount || {};

  const data = Object.entries(categories).filter(([name]) => name !== "N/A").map(([name, value], index) => ({
    name,
    value,
    itemStyle: {
      color: [
        "#42A5F5", // Sales
        "#66BB6A", // Support
        "#FFA726", // Billing
        "#AB47BC", // General
      ][index],
    },
  }));

  const noData = data.every(item => item.value === 0);

  const option = {
    title: {
      text: "Category Distribution",
      left: "left",
      textStyle: {
        fontSize: 14,
        fontWeight: 700,
        color: "#464646",
      },
    },
    tooltip: {
      trigger: "item",
      formatter: "{b}: {c} ({d}%)",
    },
    legend: {
      bottom: 0,
      left: "center",
    },
    series: [
      {
        name: "Category Distribution",
        type: "pie",
        radius: ["45%", "70%"],
        center: ["50%", "50%"],
        padAngle: 4,
        itemStyle: {
          borderRadius: 8,
        },
        label: {
          formatter: "{b}: {c}",
          fontSize: 13,
          fontWeight: 600,
        },
        data,
      },
    ],
  };

  const onEvents = {
    click: (params) => {
      if (params?.name && onCategoryClick) {
        onCategoryClick(params.name);
      }
    },
  };

  return (
    <Box sx={{ height: "50vh", width: "100%" }}>
      {!noData ? (
        <ReactECharts
          option={option}
          style={{ height: "100%" }}
          opts={{ renderer: "svg" }}
          onEvents={onEvents}
        />
      ) : (
        <Box
          height="100%"
          display="flex"
          alignItems="center"
          justifyContent="center"
          color="#999"
          fontWeight={600}
        >
          No data available
        </Box>
      )}
    </Box>
  );
};

export default CategoryDistribution;
